var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.refNum)?_c('v-chip',{attrs:{"color":_vm.color,"label":"","small":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.refNum)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }